import { skipToken, useQuery } from "@tanstack/react-query";
import React from "react";
import { setPath } from "remeda";
import type { Organization } from "types/Organization";
import { API2Context } from "@/utils/api2";
import { getOrganizationQueryKey } from "./keys";

export function useGetOrganization(
	organizationId: string | undefined,
	includeLegal: boolean,
	includeRoles: boolean,
) {
	const api = React.useContext(API2Context);
	const queryKey = getOrganizationQueryKey(
		organizationId,
		includeLegal,
		includeRoles,
	);
	const { data, isError, isPending } = useQuery({
		queryKey,
		queryFn: organizationId
			? () =>
					api
						.get<Organization>(`/v1/org/${organizationId}`, {
							params: {
								includeLegal,
								includeRoles,
							},
						})
						.then((res) => res.data)
			: skipToken,
		select: (data) => {
			const d = structuredClone(data);
			setPath(d, ["membership", "lastActivityAt"], undefined);
			return d;
		},
	});

	return {
		organization: data,
		isError,
		isLoading: isPending,
	};
}
